// www2.profitwell.com/app/engagement
export const logProfitWellEmail = (customerEmail: string) => {
  const profitwell = (window as any)?.profitwell as any;

  profitwell?.('start', {
    user_email: customerEmail,
  });
};
